export default __webpack_public_path__ + "static/media/google-play-black.bf0de477.png";